import { Component, Model, Watch } from 'vue-property-decorator'
import BasePage from '@/views/BasePage'
@Component({})
export default class TModelBase extends BasePage {
    @Model('change', { type: Boolean })
    protected value!: boolean;

    @Watch('value')
    protected onValueChange(val) {
        this.showTModel = val;
    }

    protected showTModel = false;


    @Watch('showTModel')
    protected onShowEditChange(val) {
        if (this['switchShowTModel']) {
            this['switchShowTModel'](val);
        }
        this.$emit('change', this.showTModel);
    }

    public mounted() {
        this.showTModel = this.value;
    }
}
